// Since this file is loaded by the Tailwind config we cannot use the ES modules import statement here.
// eslint-disable-next-line @typescript-eslint/no-var-requires
const plugin = require('tailwindcss/plugin');

module.exports = plugin(({ addUtilities, theme }) => {
  const heading = {
    lineHeight: theme('lineHeight.snug'),
  };

  const newUtilities = {
    '.display-1': Object.assign({}, heading, {
      fontWeight: theme('fontWeight.bold'),
      fontSize: theme('fontSize.5xl'),
    }),
    '.display-2': Object.assign({}, heading, {
      fontWeight: theme('fontWeight.medium'),
      fontSize: theme('fontSize.4xl'),
    }),
    '.display-3': Object.assign({}, heading, {
      fontWeight: theme('fontWeight.medium'),
      fontSize: theme('fontSize.3xl'),
    }),
    '.display-4': Object.assign({}, heading, {
      fontWeight: theme('fontWeight.medium'),
      fontSize: theme('fontSize.2xl'),
    }),
    '.display-5': Object.assign({}, heading, {
      fontWeight: theme('fontWeight.medium'),
      fontSize: theme('fontSize.xl'),
    }),
    '.display-6': Object.assign({}, heading, {
      fontWeight: theme('fontWeight.medium'),
      fontSize: theme('fontSize.lg'),
    }),
    '.link': {
      color: theme('colors.secondary.DEFAULT'),
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
    '.intro': {
      fontWeight: theme('fontWeight.light'),
      fontSize: theme('fontSize.enlarged'),
    },
    '.rtl': {
      direction: 'rtl',
    },
  };

  newUtilities['.rich-text'] = {
    '> * + *': {
      marginTop: '0.5em',
    },
    h1: newUtilities['.display-3'],
    h2: newUtilities['.display-4'],
    h3: newUtilities['.display-5'],
    h4: newUtilities['.display-6'],
    h5: newUtilities['.display-7'],
    h6: newUtilities['.display-8'],
    ul: {
      listStyleType: 'disc',
      paddingLeft: '1em',
      marginBottom: '1em',
    },
    ol: {
      listStyleType: 'decimal',
    },
    a: newUtilities['.link'],
    b: {
      fontWeight: theme('fontWeight.medium'),
    },
    strong: {
      fontWeight: theme('fontWeight.medium'),
    },
    i: {
      fontStyle: 'italic',
    },
    em: {
      fontStyle: 'italic',
    },
    p: {
      marginBottom: '1em',
    },
  };

  addUtilities(newUtilities);
});
